/**
 * 组件的emit事件声明
 */
export const emits = [
  /** 点击左侧区域 */
  'click-left',
  /** 点击右侧区域 */
  'click-right',
];
